<template>
  <div>
    <Title title="SOC"
           subtitle="Revisa el estado de las Socs"/>
    <el-row class="content">
      <el-form v-loading="filtersLoading"
               :inline="true">
        <el-form-item>
          <el-input v-model="filter.suborders_code"
                    placeholder="SUBORDEN"
                    clearable/>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filter.suborders_do"
                    placeholder="DO"
                    clearable/>
        </el-form-item>
        <el-form-item>
          <el-button class="default searchBttn" @click="handleSearch">
            <i class="fa fa-search"></i>
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <div v-loading="loading">
      <el-row>
        <el-col :span="23" class="do-body">
          <el-table :data="suborders"
                    size="small"
                    height="440">
            <el-table-column label="SUBORDEN"
                             prop="code"/>
            <el-table-column label="DO"
                             prop="do"/>
            <el-table-column label="TIPO"
                             prop="delivery_method.method"/>
            <el-table-column label="ESTADO">
              <template slot-scope="scope">
                {{stateSoc(scope)}}
              </template>
              <!--prop="packages[0].states[0].state_type.type"-->
            </el-table-column>
            <el-table-column label="PAQUETES"
                             type="expand"
                             width="200">
              <!-- TODO: Agregar fecha pactada cuando el servicio retorne ese dato  -->
              <template slot-scope="scope">
                <el-table :data="scope.row.packages" size="mini">
                  <el-table-column align="center" label="NOMBRE"
                                   prop="description"/>
                  <el-table-column align="center" label="ALTURA"
                                   prop="height"/>
                  <el-table-column align="center" label="ANCHO"
                                   prop="width"/>
                  <el-table-column align="center" label="LARGO"
                                   prop="length"/>
                  <el-table-column align="center" label="PESO"
                                   prop="weight"/>
                </el-table>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20" :offset="2" class="toolbar">
          <el-pagination layout="total, prev, pager, next"
                         @current-change="handleCurrentChange"
                         :page-size="10"
                         :pager-count="5"
                         :total="totalSize"
                         style="float:right;">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { apiRequest } from '../../backend/vue-axios/axios';
import Title from '../components/base/Title.vue';

export default {
  name: 'Suborder',
  components: {
    Title,
  },
  data() {
    return {
      filter: {},
      suborders: [],
      subordersData: [],
      methodsTypes: [],
      filtersLoading: false,
      loading: false,
      totalSize: 0,
    };
  },
  methods: {
    getStatus(params = {}) {
      this.loading = true;
      apiRequest({
        module: 'tracing',
        service: 'get_suborders',
        params,
      }).then((res) => {
        this.subordersData = JSON.parse(JSON.stringify(res.data));
        this.suborders = res.data;
        this.totalSize = parseInt(res.headers['x-total-count'], 10);
        this.loading = false;
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Problemas al cargar las subordenes',
        });
        this.loading = false;
      });
    },
    getLimitPage(page) {
      return ((page - 1) * 10);
    },
    handleCurrentChange(newPage) {
      this.getStatus({
        offset: this.getLimitPage(newPage),
      });
    },
    handleSearch() {
      this.getStatus(this.filter);
    },
    formatter(row) {
      return `${row.description.substr(0, 15)} ...`;
    },
    stateSoc(row) {
      const thisCode = row.row.code;
      const subOrderSelected = this.subordersData.find(d => d.code === thisCode);
      // eslint-disable-next-line
      const pakaches = subOrderSelected.packages.map((d) => {
        return d.states.map((e) => {
          const selectedType = {};
          // eslint-disable-next-line
          selectedType["create"] = e.created_at;
          // eslint-disable-next-line
          selectedType["state"] = e.state_type.type;
          return selectedType;
        });
      })[0];
      let tempData = moment('1900-01-01');
      let maxState = '';
      if (pakaches) {
        for (let i = 0; i < pakaches.length; i += 1) {
          if (moment(tempData).isBefore(pakaches[i].create)) {
            tempData = pakaches[i].create;
            maxState = pakaches[i].state;
          }
        }
      }
      return maxState;
    },
  },
  beforeMount() {
    this.getStatus();
  },
};

</script>

<style lang="scss" scoped>
  .el-table__fixed {
    z-index: 1 !important;
  }
  .do-body {
    text-align: left;
  }
  .searchBttn {
    height: 40px;
  }
  .wrap {
    display: block;
  }
  .content {
    text-align: left;
  }
</style>
